import { useTranslation } from 'react-i18next';
import type { JournalSourcesState } from '@/hooks/useJournalSources';
import styles from './JournalSourceState.module.css';

interface JournalSourceStateProps {
  state: JournalSourcesState;
  onRetry: () => void;
}

/** Shared non-empty loading/failure state for Scripture Journal routes. */
export default function JournalSourceState({
  state,
  onRetry,
}: JournalSourceStateProps) {
  const { t } = useTranslation();

  if (state === 'ready') return null;

  if (state === 'loading') {
    return (
      <p className={styles.status} role="status">
        {t('bookmark.loading')}
      </p>
    );
  }

  return (
    <div className={styles.failure} role="alert">
      <p>{t('bookmark.loadFailed')}</p>
      <button type="button" className={styles.retry} onClick={onRetry}>
        {t('bookmark.tryAgain')}
      </button>
    </div>
  );
}
